import { useState } from "react";
import { deleteInteraction } from "../../../../core/api/interactions/interactions";
import { notifyApiErrors } from "../../../../core/helpers/helpers";
import useTranslations from "../../../../core/i18n/useTranslations";
import useUser from "../../../../core/user/useUser";
import { notify } from "../../../../ui-lib/components/Alerts/Toast";
import PrimeModal from "../../../../ui-lib/components/PrimeModal/PrimeModal";

export const DeleteInteractionModal = ({
  objectId,
  interactionId,
  onClose,
  onDelete,
}: {
  objectId: string;
  interactionId?: number;
  onClose: () => void;
  onDelete: () => void;
}) => {
  const t = useTranslations();

  const { authenticatedRequest } = useUser();

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async () => {
    if (!interactionId) {
      return;
    }

    try {
      setIsLoading(true);
      await deleteInteraction(objectId, interactionId, authenticatedRequest);
      notify({
        message: t("Messages:delete_interaction_success"),
      });
      onDelete();
    } catch (error: any) {
      notifyApiErrors(error.response?.data?.errors);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PrimeModal
      withFooter
      withHeader
      isOpen={!!interactionId}
      loading={isLoading}
      header={t("Objects:delete_interaction")}
      onClose={onClose}
      fixedWidth="576px"
      submitBtn={{
        text: t("Common:delete"),
        variant: "destructive",
        onClick: onSubmit,
      }}
      cancelBtn={{
        text: t("Common:cancel"),
        onClick: onClose,
      }}
    >
      <p className="grey-600">{t("Messages:delete_interaction_confirm")}</p>
    </PrimeModal>
  );
};
